import React from 'react';
import logo from './butterflywings logo.png'; // Adjust the path based on your file structure
import giphyImage from './giphy.webp'; // First image
import giphyImage2 from './giphy (1).webp'; // Second image
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const App = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  return (
    <div style={styles.body}>
      {/* First Navbar */}
      <nav style={styles.navbar}>
        <img src={logo} alt="Butterflywings Logo" style={styles.logo} />
      </nav>

      {/* Second Navbar (no space below the first) */}
      <nav style={styles.navbarSecond}>
        {/* Buttons inside the second navbar */}
        <div style={styles.buttonContainer}>
        <button style={styles.button}onClick={() => navigate('/aivoiceassistant')}>AI Assistant</button>
        <button style={styles.button}onClick={() => navigate('/aboutus')}>AboutUs</button>
          <button style={styles.button}onClick={() => navigate('/products')}>Our Products</button>
          <button style={styles.button}onClick={() => navigate('/register')}>SignUp</button>
          <button style={styles.button} onClick={() => navigate('/login')}>Login</button> {/* Updated Login button */}
        </div>
      </nav>

      {/* Main body content */}
      <div style={styles.mainContent}>
        {/* Image on the left side */}
        <img src={giphyImage} alt="Giphy" style={styles.giphyImage} />

        {/* Description Container */}
        <div style={styles.descriptionContainer}>
          <h1 style={styles.descriptionTitle}>Welcome to ButterflyWings</h1>
          <p style={styles.descriptionText}>
            Your trusted partner in innovative software solutions. We specialize in developing secure, responsive, and high-performance applications tailored to meet your business needs.
          </p>
        </div>
      </div>

      {/* Main body content for second section */}
      <div style={styles.mainContent1}>
        {/* Image on the left side */}
        <img src={giphyImage2} alt="Giphy(1)" style={styles.giphyImage} />
        {/* Description for the second section */}
        <div style={styles.content}>
          <h1 style={styles.fastDeliveryTitle}>WE DELIVER FAST</h1>
          <p style={styles.fastDeliveryTitle1}>Secured, Responsive, High Performance</p>
        </div>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <p>&copy; 2024 ButterfluWings Software Company Pvt Ltd</p>
      </footer>
    </div>
  );
};

const styles = {
  body: {
    backgroundColor: 'black',
    color: '#00FFFF', // Bright teal
    margin: 0,
    fontFamily: 'Arial, sans-serif',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  navbar: {
    backgroundColor: 'white',
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0', // Ensure no space below the first navbar
    border: '5px solid #00FFFF', // Add border color and thickness
    boxShadow: '0 2px 5px rgba(0, 255, 255, 0.3)', // Optional shadow for depth
  },
  logo: {
    width: '150px', // Adjust the size as needed
    height: 'auto',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap', // Allow buttons to wrap on smaller screens
  },
  button: {
    backgroundColor: '#00FFFF',
    color: 'black',
    border: 'none',
    padding: '10px 20px',
    margin: '5px', // Adjust margin for better spacing
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    boxShadow: '0 5px 15px rgba(0, 255, 255, 0.3)', // Shadow effect
    transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column', // Stack on smaller screens
    padding: '20px',
    alignItems: 'center',
  },
  mainContent1: {
    display: 'flex',
    flexDirection: 'column', // Stack on smaller screens
    padding: '20px',
    alignItems: 'center',
  },
  descriptionContainer: {
    flex: 1,
    marginLeft: '20px', // Space between the description and the image
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // Center vertically
    alignItems: 'flex-start', // Align items to the start
    color: '#00FFFF', // Bright teal for the text
    height: '200px', // Set a fixed height to center the text
  },
  descriptionTitle: {
    fontSize: '2rem', // Bigger font size for the title
    margin: 0,
  },
  descriptionText: {
    fontSize: '1.2rem', // Adjust font size for description text
  },
  giphyImage: {
    width: '100%', // Make the image responsive
    maxWidth: '300px', // Limit the max width of the image
    height: 'auto',
  },
  content: {
    color: '#00FFFF', // Bright teal for the main content
    textAlign: 'center', // Center text for better readability
  },
  fastDeliveryTitle: {
    marginBottom: '20px', // Space between title and the image
    fontSize: '2rem', // Adjust size as needed
  },
  fastDeliveryTitle1: {
    marginBottom: '20px', // Space between title and the image
    fontSize: '1rem', // Adjust size as needed
  },
  footer: {
    backgroundColor: '#00FFFF',
    padding: '10px',
    textAlign: 'center',
    color: 'black',
  },
};

// Add media queries for responsiveness
const mediaQueries = `\
  @media (max-width: 768px) {
    .navbar {
      flex-direction: column; // Stack navbar items vertically on smaller screens
    }
    .descriptionContainer {
      align-items: center; // Center align items in the description container
      text-align: center; // Center text for smaller screens
      margin-left: 0; // Remove margin on smaller screens
    }
    .mainContent, .mainContent1 {
      flex-direction: column; // Stack items vertically on smaller screens
      align-items: center; // Center align items
    }
    .giphyImage {
      max-width: 100%; // Make the images full width on small screens
    }
  }
`;

// Append media queries to the head
const styleTag = document.createElement("style");
styleTag.innerHTML = mediaQueries;
document.head.appendChild(styleTag);

export default App;
